import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import {
	consultaEntidadeMilitarSuccess,
	consultaEntidadeMilitarFailure,
} from './actions';

function* consultaEntidadeMilitar() {
	const response: ApiResponse = yield call(
		getApi,
		PATH_DETRAN_CNH,
		`consulta/${CHANNEL}/entidade-militar`,
		{},
	);

	if (response.status === 200) {
		yield put(consultaEntidadeMilitarSuccess(response));
	} else if (response.error) {
		yield put(consultaEntidadeMilitarFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTA_ENTIDADE_MILITAR_REQUEST, consultaEntidadeMilitar),
]);
